module.exports = function () {
    if ($('.location-directory').length === 0) {
        return;
    }

    var loadMap = function ($placeholder, location) {
        var mapOptions = {
            zoom: 13,
            key: window.ICFGoogleMapsKey,
            center: location,
            size: '315x370',
            markers: location
        };

        var mapOptionsQuery = Object.keys(mapOptions).filter(function (key) {
            return mapOptions.hasOwnProperty(key);
        }).map(function (key) {
            return key + '=' + encodeURIComponent(mapOptions[key].toString());
        }).join('&');

        var $mapItem = $('<img style="width: 100%; height: auto; border: none;" src="https://maps.googleapis.com/maps/api/staticmap?' + mapOptionsQuery + '"/>');
        $placeholder.parent().append($mapItem);

        $mapItem[0].onload = function() {
            $placeholder.remove();
        };
    };

    $('.location-directory__location-link').click(function () {
        $(this).closest('.location-directory__container').find('.location-directory__tab-content-active').removeClass('location-directory__tab-content-active')
        $(this).closest('.location-directory__tab-content').addClass('location-directory__tab-content-active');
        
        var $clickedLocation = $(this).parents('.location-directory__location').first();

        $clickedLocation.find('[data-location]').each(function () {
            var $container = $(this);
            var $placeholder = $container.find('.location-directory__location-details-map-image-placeholder');
            if ($placeholder.length) {
                loadMap($placeholder, $container.data('location'));
            }
        });
    });

    $('.location-directory__location-link').modaal({ custom_class: "location-directory__detail-modal" });

    var id = window.location.hash.substring(1);

    if (id.length) {
        var $locationLink = $('[href="#' + id + '"]').first();

        if ($locationLink.length) {
            var tabId = $locationLink.closest('.tabs-module__tab-pane').attr('aria-labelledby');
            $('#' + tabId).click();
            $locationLink.click();
        }

        history.replaceState("", document.title, window.location.pathname + window.location.search);
    }
   
    var handleRegionTriggerClick = function ($trigger) {
        var $contentContainer = $trigger.closest('.location-directory__region-container').find('.location-directory__region-content-container');
        if ($trigger.attr('aria-expanded') == 'true') {
            $trigger.attr('aria-expanded', 'false');
            if ($contentContainer.length) {
                $contentContainer.attr('aria-hidden', 'true');
                $contentContainer.find('a').attr('tabindex', '-1');

                $contentContainer.css('height', '');
            }
        }
        else {
            $trigger.attr('aria-expanded', 'true');
            if ($contentContainer.length) {
                $contentContainer.attr('aria-hidden', 'false');
                $contentContainer.find('a').attr('tabindex', '');

                var containerInnerHeight = $contentContainer.find('.location-directory__region-content-container-inner').outerHeight(true);
                var containerHeightValue = containerInnerHeight + 'px';
                $contentContainer.css('height', containerHeightValue);
            }
        }
    }
    $('.location-directory__region-trigger').on('click', function () {
        var $trigger = $(this);
        handleRegionTriggerClick($trigger);
    });

    var setBreakpointAppropriateTriggerState = function () {
        var $trigger = $('.location-directory__region-trigger');
        if (!ICF.Utils.Breakpoints.IsAtLeastDesktopSm()) {
            $trigger.attr('disabled', false);
            if ($trigger.attr('aria-expanded') == 'true') {
                handleRegionTriggerClick($trigger);
            }
        }
        if (ICF.Utils.Breakpoints.IsAtLeastDesktopSm()) {
            $trigger.attr('disabled', true);
            if ($trigger.attr('aria-expanded') == 'false') {
                handleRegionTriggerClick($trigger);
            }
        }
    }

    setBreakpointAppropriateTriggerState();

    $(window).resize(function () {
        window.setTimeout(setBreakpointAppropriateTriggerState(), 0);
    });
};
